import { useFormContext } from 'react-hook-form';

import { type BlockedUserCreationFormType } from './schema';

export const useBlockedUserCreationFormContext = useFormContext<BlockedUserCreationFormType>;
